module.exports = __webpack_public_path__ + "img/logo3.bd273fab.png";